import React from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import first from "../images/exvrden/exvrden-1.png";
import second from "../images/exvrden/exvrden-2.png";
import third from "../images/exvrden/exvrden-3.png";
import fourth from "../images/exvrden/exvrden-4.png";
import fifth from "../images/exvrden/exvrden-5.png";
import sixth from "../images/exvrden/exvrden-6.png";
import seventh from "../images/exvrden/exvrden-7.png";
import eighth from "../images/exvrden/exvrden-8.png";

function Inspection() {
  const { t } = useTranslation();

  return (
    <section className="inspection-section" style={{ padding: "15rem 0" }}>
      <div className="container">
        <div className="inspection-content">
          <h1 style={{
            fontSize: "3.5rem",
            textAlign: "center",
            marginBottom: "2rem",
            color: "#ff4d30"
          }}>
            {t('inspection.title')}
          </h1>

          <p style={{
            fontSize: "1.8rem",
            textAlign: "center",
            marginBottom: "3rem",
            color: "#706f7b"
          }}>
            {t('inspection.description')}
          </p>

          <div className="main-img" style={{
            width: "100%",
            height: "700px",
            marginTop: "10rem",
            marginBottom: "10rem"
          }}>
            <img
              src={first}
              alt="first"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "10px",
              }}
            />
          </div>
          <h1 style={{ fontSize: "3.5rem", textAlign: "center", marginBottom: "2rem", color: "#ff4d30" }}>
            {t('inspection.gallery.title')}
          </h1>
          <div className="swiper-container" style={{ padding: "0 90px", position: "relative" }}>
            <Swiper
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              modules={[Navigation]}
              className="offer-swiper"
              slidesPerView={3}
              spaceBetween={30}
              loop={true}
            >
              {[second, third, fourth, fifth, sixth, seventh, eighth, first].map((image, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={image}
                    alt={`Slider ${index + 1}`}
                    onClick={() => {
                      const modal = document.createElement('div');
                      modal.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.8);display:flex;justify-content:center;align-items:center;z-index:1000;';
                      const img = document.createElement('img');
                      img.src = image;
                      img.style.cssText = 'max-width:80%;max-height:80%;object-fit:contain;';
                      modal.appendChild(img);
                      modal.onclick = () => document.body.removeChild(modal);
                      document.body.appendChild(modal);
                    }}
                    style={{
                      width: "100%",
                      height: "200px",
                      objectFit: "cover",
                      border: "2px solid #dddddd73",
                      borderRadius: "10px",
                      padding: "5px",
                      cursor: "pointer"
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
            <div
              className="swiper-button-prev"
              style={{
                color: "#ff4d30",
                border: "2px solid #ff4d30",
                borderRadius: "50%",
                padding: "10px",
                width: "65px",
                height: "65px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "absolute",
                left: "0",
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: "10"
              }}
            />
            <div
              className="swiper-button-next"
              style={{
                color: "#ff4d30",
                border: "2px solid #ff4d30",
                borderRadius: "50%",
                padding: "10px",
                width: "65px",
                height: "65px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "absolute",
                right: "0",
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: "10"
              }}
            />
          </div>

          <div style={{ padding: "10rem 0" }}>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "3rem",
              marginTop: "5rem"
            }}>
              <div className="offer-box">
                <h3 style={{ fontSize: "2.4rem", marginBottom: "2rem", color: "#ff4d30" }}>
                  {t('inspection.features.standard.title')}
                </h3>
                <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                  {t('inspection.features.standard.description')}
                </p>
              </div>

              <div className="offer-box">
                <h3 style={{ fontSize: "2.4rem", marginBottom: "2rem", color: "#ff4d30" }}>
                  {t('inspection.features.credibility.title')}
                </h3>
                <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                  {t('inspection.features.credibility.description')}
                </p>
              </div>

              <div className="offer-box">
                <h3 style={{ fontSize: "2.4rem", marginBottom: "2rem", color: "#ff4d30" }}>
                  {t('inspection.features.rating.title')}
                </h3>
                <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                  {t('inspection.features.rating.description')}
                </p>
              </div>

              <div className="offer-box">
                <h3 style={{ fontSize: "2.4rem", marginBottom: "2rem", color: "#ff4d30" }}>
                  {t('inspection.features.standardization.title')}
                </h3>
                <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                  {t('inspection.features.standardization.description')}
                </p>
              </div>

              <div className="offer-box">
                <h3 style={{ fontSize: "2.4rem", marginBottom: "2rem", color: "#ff4d30" }}>
                  {t('inspection.features.solution.title')}
                </h3>
                <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                  {t('inspection.features.solution.description')}
                </p>
              </div>

              <div className="offer-box">
                <h3 style={{ fontSize: "2.4rem", marginBottom: "2rem", color: "#ff4d30" }}>
                  {t('inspection.features.leads.title')}
                </h3>
                <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                  {t('inspection.features.leads.description')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="how-section" style={{ padding: "8rem 0" }}>
          <div className="how-content" style={{ display: "flex", alignItems: "center", gap: "5rem" }}>
            <div className="how-content__text" style={{ flex: "1" }}>
              <h3 style={{ fontSize: "3rem", marginBottom: "4rem", color: "#ff4d30" }}>
                {t('inspection.howItWorks.title')}
              </h3>

              <div className="how-steps" style={{ display: "flex", flexDirection: "column", gap: "3rem" }}>
                <div className="step">
                  <h4 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
                    {t('inspection.howItWorks.steps.step1.title')}
                  </h4>
                  <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                    {t('inspection.howItWorks.steps.step1.description')}
                  </p>
                </div>

                <div className="step">
                  <h4 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
                    {t('inspection.howItWorks.steps.step2.title')}
                  </h4>
                  <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                    {t('inspection.howItWorks.steps.step2.description')}
                  </p>
                </div>

                <div className="step">
                  <h4 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
                    {t('inspection.howItWorks.steps.step3.title')}
                  </h4>
                  <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                    {t('inspection.howItWorks.steps.step3.description')}
                  </p>
                </div>

                <div className="step">
                  <h4 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
                    {t('inspection.howItWorks.steps.step4.title')}
                  </h4>
                  <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                    {t('inspection.howItWorks.steps.step4.description')}
                  </p>
                </div>
              </div>
            </div>

            <div className="how-content__img" style={{ flex: "1" }}>
              <img
                src={require("../images/exvrden/exvrden-5.png")}
                alt="how it works"
                style={{ width: "100%", borderRadius: "20px", border: "2px solid #0000001c" }}
              />
            </div>
          </div>
        </div>
        <h1 style={{ fontSize: "3.5rem", textAlign: "center", marginBottom: "2rem", color: "#ff4d30" }}>
          {t('inspection.livePreview.title')}
        </h1>
        <div className="iframe-container" style={{
          position: "relative",
          overflow: "hidden",
          width: "90%",
          height: "575px",
          margin: "0 auto",
          border: "2px solid #0000001f",
          borderRadius: "20px"
        }}>
          <div style={{
            position: "absolute",
            top: "10px",
            right: "15px",
            backgroundColor: "#ff4d30",
            padding: "5px 7.5px",
            borderRadius: "250px",
            color: "white",
            fontSize: "12px",
            zIndex: "10",
          }}>
            <a href="https://exvrden.com" target="_blank" rel="noopener noreferrer" style={{ color: "white", textDecoration: "none" }}>
              {t('inspection.livePreview.reviewLink')}
            </a>
          </div>
          <iframe
            src="https://exvrden.com"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              width: "100%",
              height: "575px",
              border: "none",
              margin: "0 auto"
            }}
            title="360 Vehicle Inspection"
            allowFullScreen
          />
        </div>

        <div style={{
          marginTop: "5rem",
          display: "flex",
          alignItems: "center",
          gap: "5rem",
          backgroundColor: "#f8f8f8",
          padding: "4rem",
          borderRadius: "10px"
        }}>
          <div className="contact-form" style={{
            maxWidth: "600px",
            margin: "50px auto",
            padding: "30px",
            backgroundColor: "#fff",
            borderRadius: "10px",
            boxShadow: "0 0 20px rgba(0,0,0,0.1)"
          }}>
            <h2 style={{
              textAlign: "center",
              marginBottom: "30px",
              color: "#333"
            }}>
              {t('inspection.contact.title')}
            </h2>

            <form style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <div style={{ display: "flex", gap: "20px" }}>
                <input
                  type="text"
                  placeholder={t('inspection.contact.form.firstName')}
                  style={{
                    flex: 1,
                    padding: "12px",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                    fontSize: "16px"
                  }}
                />
                <input
                  type="text"
                  placeholder={t('inspection.contact.form.lastName')}
                  style={{
                    flex: 1,
                    padding: "12px",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                    fontSize: "16px"
                  }}
                />
              </div>

              <input
                type="email"
                placeholder={t('inspection.contact.form.email')}
                style={{
                  padding: "12px",
                  border: "1px solid #ddd",
                  borderRadius: "5px",
                  fontSize: "16px"
                }}
              />

              <input
                type="tel"
                placeholder={t('inspection.contact.form.phone')}
                style={{
                  padding: "12px",
                  border: "1px solid #ddd",
                  borderRadius: "5px",
                  fontSize: "16px"
                }}
              />

              <input
                type="text"
                placeholder={t('inspection.contact.form.company')}
                style={{
                  padding: "12px",
                  border: "1px solid #ddd",
                  borderRadius: "5px",
                  fontSize: "16px"
                }}
              />

              <textarea
                placeholder={t('inspection.contact.form.message')}
                rows="5"
                style={{
                  padding: "12px",
                  border: "1px solid #ddd",
                  borderRadius: "5px",
                  fontSize: "16px",
                  resize: "vertical"
                }}
              ></textarea>

              <button
                type="submit"
                style={{
                  padding: "15px",
                  backgroundColor: "#ff4d30",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  fontSize: "16px",
                  cursor: "pointer",
                  transition: "background-color 0.3s"
                }}
              >
                {t('inspection.contact.form.sendButton')}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Inspection;
